import axios from 'axios';
import { API_CONFIG } from './config';
import { readAuth, clearAuth } from '../auth/authStorage';

export const apiClient = axios.create({
  baseURL: API_CONFIG.baseUrl,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30_000,
});

apiClient.interceptors.request.use((config) => {
  const auth = readAuth();
  if (auth?.token) {
    config.headers.Authorization = `Bearer ${auth.token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;

      if (status === 401 || status === 403) {
        clearAuth();
        window.location.href = '/login';
        return Promise.reject(error);
      }

      const message =
        error.response?.data?.message ||
        error.response?.data?.error_code ||
        error.message;
      return Promise.reject(new Error(message));
    }
    return Promise.reject(error);
  },
);
